/* PDP presentation: keep the native product form, variant fragments and gallery handlers. */
(() => {
  'use strict';
  if (!document.body.classList.contains('tt12-template-product')) return;
  const desktop = matchMedia('(min-width: 990px)');
  const layouts = new WeakMap();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const clean = value => value.replace(/\s+/g, ' ').trim();
  function accordion(label, className) {
    const details = document.createElement('details'); details.className = className;
    const summary = document.createElement('summary');
    const text = document.createElement('span'); text.textContent = label;
    const indicator = document.createElement('span'); indicator.className = 'tt13-commerce-details-indicator'; indicator.setAttribute('aria-hidden', 'true');
    summary.append(text, indicator); details.append(summary); return details;
  }
  function description(root, purchase) {
    const details = root.querySelector('.product-block-description.tt13-commerce-product-details');
    const body = details?.querySelector('.tt13-commerce-description'); if (!body) return;
    const original = [...body.childNodes], groups = {details: [], specs: [], sizes: []}; let group = 'details';
    for (const node of original) {
      if (node.nodeType === 1) {
        const lead = clean(node.querySelector('strong,b')?.textContent || node.textContent);
        const heading = /^H[1-6]$/.test(node.tagName) || node.matches('p') && !!node.querySelector('strong,b');
        if (heading && /^(size chart|size guide)\b/i.test(lead)) group = 'sizes';
        else if (heading && /^(styles|features|key features|care instructions|made with premium|full plush size|weight|measurements|size|product details|what.?s in a box|rarity|the cast)\b/i.test(lead)) group = 'specs';
        else if (heading && /^(product overview|perfect for you)\b/i.test(lead)) group = 'details';
      }
      groups[group].push(node);
    }
    body.replaceChildren(...groups.details);
    details.querySelector('summary span').textContent = 'Details';
    const meaningful = nodes => nodes.some(n => clean(n.textContent) || n.nodeType === 1 && (n.matches('img,table,video,iframe') || n.querySelector('img,table,video,iframe')));
    details.open = clean(body.textContent).length <= 320;
    if (!meaningful(groups.details)) details.hidden = true;
    if (meaningful(groups.specs)) {
      const specs = accordion('Specs', 'tt13-commerce-product-details toasty-pdp-specs');
      const content = document.createElement('div'); content.className = 'rte tt13-commerce-description'; content.append(...groups.specs); specs.append(content); details.after(specs);
    }
    if (meaningful(groups.sizes)) {
      const guide = accordion('Size guide', 'tt13-commerce-product-details toasty-pdp-size-guide');
      const content = document.createElement('div'); content.className = 'rte tt13-commerce-description'; content.append(...groups.sizes);
      content.querySelectorAll('img:not([alt]),img[alt=""]').forEach(img => img.alt = `Size chart for ${clean(root.querySelector('h1').textContent)}`);
      guide.append(content); purchase.prepend(guide);
    }
  }
  function desktopLayout(root) {
    let state = layouts.get(root);
    if (!state) {
      const holder = root.querySelector('.toasty-pdp-columns');
      if (!holder) return;
      const information = holder.querySelector('.toasty-pdp-information');
      const purchase = holder.querySelector('.toasty-pdp-purchase');
      const items = [...information.children, ...purchase.children].map(node => {
        const marker = document.createComment(''); node.before(marker); return {node, marker};
      });
      const panel = document.createElement('div'); panel.className = 'toasty-pdp-desktop'; panel.hidden = true; holder.append(panel);
      const intro = [...root.querySelectorAll('.product-block-description .tt13-commerce-description p')].find(p => clean(p.textContent));
      const brief = document.createElement('p'); brief.className = 'toasty-pdp-brief'; brief.textContent = intro ? clean(intro.textContent) : '';
      state = {items, panel, brief, mode: false, open: new Map(), reviews: []}; layouts.set(root, state);
    }
    if (desktop.matches && !state.mode) {
      const rank = node => node.matches('.product-block-title') ? 0 : node.matches('.product-block-price') ? 1
        : node.matches('.shopify-app-block') ? 2 : node.matches('.product-block-variant-picker') ? 3
        : node.matches('.product-block-quantity-selector') ? 4 : node.matches('.product-block-buy-buttons') ? 5
        : node.matches('.product-block-description') ? 6 : node.matches('.toasty-pdp-specs') ? 7
        : node.matches('.toasty-pdp-size-guide') ? 8 : (node.matches('.toasty-pdp-shipping') || node.querySelector('.toasty-pdp-shipping')) ? 9
        : node.matches('.tt13-commerce-category-link') ? 11 : 5;
      const ordered = [...state.items].sort((a,b) => rank(a.node)-rank(b.node));
      ordered.forEach(({node}) => state.panel.append(node));
      if (state.brief.textContent) {
        const price = state.panel.querySelector('.product-block-price');
        if (price) price.after(state.brief); else state.panel.querySelector('.product-block-title')?.after(state.brief);
      }
      state.panel.querySelectorAll('details').forEach(d => {state.open.set(d,d.open);d.open=false;});
      state.panel.hidden = false; state.mode = true;
    } else if (!desktop.matches && state.mode) {
      state.items.forEach(({node,marker}) => marker.after(node));
      state.open.forEach((open,node) => {node.open=open;}); state.open.clear();
      state.reviews.forEach(({node,marker,origin}) => {marker.after(node);node.open=false;origin?.removeAttribute('data-toasty-review-origin');});
      state.reviews = []; state.panel.hidden = true; state.mode = false;
    }
    if (desktop.matches) {
      document.querySelectorAll('.toasty-pdp-reviews').forEach(node => {
        if (state.panel.contains(node)) return;
        const marker = document.createComment(''); node.before(marker);
        const origin = node.closest('.shopify-section'); state.reviews.push({node,marker,origin});
        const category = state.panel.querySelector('.tt13-commerce-category-link');
        if (category) category.before(node); else state.panel.append(node);
        node.open = false;
        if (origin && !clean(origin.textContent) && !origin.querySelector('img,form,iframe,video')) origin.dataset.toastyReviewOrigin='empty';
      });
    }
  }
  function options(root) {
    root.querySelectorAll('[data-product-option]').forEach(fieldset => {
      const legend = fieldset.querySelector('legend'); if (!legend) return;
      fieldset.dataset.toastyOptionSize = /\bsize\b/i.test(legend.textContent) ? 'true' : 'false';
    });
  }
  function product(root) {
    if (root.dataset.toastyPdpReady) { options(root); desktopLayout(root); return; }
    const content = root.querySelector('.product-content'), container = content?.querySelector('.product-block-container'), holder = container?.firstElementChild;
    if (!holder) return;
    const media = root.querySelector('.product-media'); const grid = media.parentElement;
    grid.classList.add('toasty-pdp-grid'); content.classList.add('toasty-pdp-content'); container.classList.add('toasty-pdp-blocks'); holder.classList.add('toasty-pdp-columns');
    const information = document.createElement('div'); information.className = 'toasty-pdp-information';
    const purchase = document.createElement('div'); purchase.className = 'toasty-pdp-purchase';
    const category = holder.querySelector('.tt13-commerce-category-link');
    [...holder.children].forEach(el => {
      if (el === category) return;
      if (el.matches('.product-block-title,.product-block-price,.product-block-description,.shopify-app-block')) information.append(el);
      else purchase.append(el);
    });
    const price = information.querySelector('.product-block-price'), title = information.querySelector('.product-block-title');
    if (title) information.prepend(title); if (price) information.prepend(price);
    holder.append(information, purchase); if (category) purchase.append(category);
    description(root, purchase); options(root); root.dataset.toastyPdpReady = 'true';
    desktopLayout(root);
  }

  function reviews() {
    document.querySelectorAll('.toasty-pdp-reviews').forEach(details => {
      const widget = details.querySelector('[data-average-rating][data-number-of-reviews]');
      const rating = Number(widget?.dataset.averageRating), count = Number(widget?.dataset.numberOfReviews);
      const target = details.querySelector('[data-toasty-review-summary]');
      if (target && Number.isFinite(rating) && Number.isFinite(count) && count >= 0 && widget) { const text = count === 0 ? '0 reviews' : `${rating.toFixed(1)} / 5 · ${count} ${count === 1 ? 'review' : 'reviews'}`; if (target.textContent !== text) target.textContent = text; }
    });
  }
  function rail(root) {
    if (root.dataset.toastyRailReady) return;
    const list = root.querySelector('ul[role="list"]'); if (!list || !list.querySelector('li:not([aria-hidden="true"])')) return;
    list.classList.add('toasty-pdp-recommendation-list'); list.id ||= `toasty-recommendations-${document.querySelectorAll('[data-toasty-rail-ready]').length}`;
    const controls = document.createElement('div'); controls.className = 'toasty-pdp-rail-controls';
    const make = (label, text) => { const button = document.createElement('button'); button.type = 'button'; button.textContent = text; button.setAttribute('aria-label', label); button.setAttribute('aria-controls', list.id); controls.append(button); return button; };
    const previous = make('Previous recommendations', '←'), next = make('Next recommendations', '→'), motion = make('Pause recommendations', 'Pause');
    list.before(controls); root.dataset.toastyRailReady = 'true';
    let paused = reduced.matches, hovered = false, focused = false, visible = false, direction = 1, manualUntil = 0;
    const overflow = () => list.querySelectorAll('li:not([aria-hidden="true"])').length > 1 && list.scrollWidth > list.clientWidth + 2;
    const label = () => { motion.textContent = paused ? 'Play' : 'Pause'; motion.setAttribute('aria-label', `${paused ? 'Play' : 'Pause'} recommendations`); motion.setAttribute('aria-pressed', String(paused)); };
    const update = () => { controls.hidden = !overflow(); previous.disabled = list.scrollLeft <= 1; next.disabled = list.scrollLeft >= list.scrollWidth - list.clientWidth - 1; };
    const move = step => { manualUntil = Date.now() + 20000; list.scrollBy({left: step * list.querySelector('li:not([aria-hidden="true"])').getBoundingClientRect().width, behavior: reduced.matches ? 'auto' : 'smooth'}); };
    previous.addEventListener('click', () => move(-1)); next.addEventListener('click', () => move(1)); motion.addEventListener('click', () => { paused = !paused; label(); });
    list.addEventListener('pointerdown', () => manualUntil = Date.now() + 20000, {passive: true});
    root.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') hovered = true; }); root.addEventListener('pointerleave', () => hovered = false);
    root.addEventListener('focusin', () => focused = true); root.addEventListener('focusout', event => focused = root.contains(event.relatedTarget));
    list.addEventListener('scroll', update, {passive: true}); new ResizeObserver(update).observe(list);
    new IntersectionObserver(entries => visible = entries[0].isIntersecting, {threshold: .2}).observe(list);
    reduced.addEventListener('change', () => { if (reduced.matches) paused = true; label(); });
    let previousFrame = 0, position = list.scrollLeft;
    const tick = now => {
      if (!root.isConnected) return;
      if (reduced.matches && !paused) { paused = true; label(); }
      const elapsed = previousFrame ? Math.min(now - previousFrame, 50) : 0; previousFrame = now;
      const running = !reduced.matches && !paused && !hovered && !focused && visible && !document.hidden && overflow() && Date.now() >= manualUntil;
      const state = String(running); if (list.dataset.toastyAutoScrolling !== state) list.dataset.toastyAutoScrolling = state;
      if (!running) { position = list.scrollLeft; requestAnimationFrame(tick); return; }
      if (Math.abs(list.scrollLeft - position) > 2) position = list.scrollLeft;
      const end = list.scrollWidth - list.clientWidth;
      if (position >= end) direction = -1; else if (position <= 0) direction = 1;
      position = Math.max(0, Math.min(end, position + direction * elapsed * .025));
      list.scrollLeft = position;
      requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
    label(); update();
  }
  desktop.addEventListener('change', () => document.querySelectorAll('.tt13-product[data-product-root]').forEach(desktopLayout));
  let pending = false;
  function enhance() {
    pending = false; document.querySelectorAll('.tt13-product[data-product-root]').forEach(product); document.querySelectorAll('.tt13-related').forEach(rail); reviews();
  }
  function start() {
    enhance();
    new MutationObserver(() => { if (!pending) { pending = true; requestAnimationFrame(enhance); } }).observe(document.querySelector('#MainContent'), {childList: true, subtree: true});
    document.addEventListener('click', event => { if (event.target.closest('.jdgm-preview-badge')) { const details = document.querySelector('.toasty-pdp-reviews'); if (details) details.open = true; } }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true}); else start();
})();
